function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useRef, useState } from 'react';
import { statusText, distanceText, durationText, arrivalText } from './TrackingDetails';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var loading;
function loadMaps(apiKey) {
  var _window$google;
  if ((_window$google = window.google) !== null && _window$google !== void 0 && (_window$google = _window$google.maps) !== null && _window$google !== void 0 && _window$google.importLibrary) return Promise.resolve(window.google.maps);
  if (!apiKey) return Promise.reject(new Error('Interactive maps need a configured Google Maps browser key. Navigation links remain available.'));
  if (!loading) loading = new Promise((resolve, reject) => {
    var script = document.createElement('script');
    var timer = setTimeout(() => {
      loading = null;
      reject(new Error('Google Maps did not load. Check your connection or use the navigation link.'));
    }, 15000);
    window.rentalVerseMapsReady = () => {
      clearTimeout(timer);
      resolve(window.google.maps);
    };
    script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(encodeURIComponent(apiKey), "&loading=async&callback=rentalVerseMapsReady&v=weekly&libraries=marker,geometry");
    script.async = true;
    script.onerror = () => {
      clearTimeout(timer);
      loading = null;
      reject(new Error('Google Maps could not load.'));
    };
    document.head.appendChild(script);
  });
  return loading;
}
// "2m ago" / "1h 5m ago" - the label chip's timing text. Relative, not a clock time, so it stays
// meaningful without the caller needing to keep re-rendering just for the clock to tick; the
// marker effect re-runs (and this re-computes) every poll cycle (15s while a trip is live).
function timeAgo(iso) {
  if (!iso) return 'no GPS yet';
  var mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins <= 0) return 'just now';
  if (mins < 60) return "".concat(mins, "m ago");
  return "".concat(Math.floor(mins / 60), "h ").concat(mins % 60, "m ago");
}
// The cab/driver marker's on-map content: a small label chip (name + last-update timing) sitting
// above a numbered status pin. The pin, not the chip, is the actual anchor point (AdvancedMarker
// content anchors at its own bottom-center), so the chip floats above the true GPS point like a
// speech bubble rather than shifting where the pin appears to sit.
function buildCabContent(n, index, route) {
  var _route$stops;
  var wrap = document.createElement('div');
  wrap.style.cssText = 'position:relative;display:flex;flex-direction:column;align-items:center;';
  var stale = !!n.location.stale;
  var label = document.createElement('div');
  label.textContent = "".concat(n.label, " \xB7 ").concat(timeAgo(n.location.at)).concat(stale ? ' (stale)' : '');
  label.style.cssText = "margin-bottom:3px;padding:2px 7px;border-radius:10px;white-space:nowrap;\n    font-size:11px;font-weight:600;line-height:1.5;color:#fff;pointer-events:none;\n    box-shadow:0 1px 4px rgba(0,0,0,.35);background:".concat(stale ? '#6c757d' : '#146c43', ";");
  var pin = document.createElement('button');
  pin.type = 'button';
  pin.textContent = String(index + 1);
  pin.title = "".concat(n.label, ": ").concat(n.status).concat(stale ? ' (stale GPS)' : '', " \u2014 last update ").concat(n.location.at ? new Date(n.location.at).toLocaleString() : 'unknown');
  pin.setAttribute('aria-label', pin.title);
  Object.assign(pin.style, {
    borderRadius: '50%',
    border: '2px solid white',
    width: '44px',
    height: '44px',
    color: 'white',
    background: stale ? '#6c757d' : '#146c43',
    fontWeight: 'bold'
  });
  var tooltip = document.createElement('div');
  tooltip.id = 'tracking-pin-' + n.kind + '-' + n.id;
  tooltip.setAttribute('role', 'tooltip');
  tooltip.style.cssText = 'display:none;position:absolute;bottom:100%;left:50%;transform:translateX(-50%);width:min(240px,70vw);white-space:pre-line;overflow-wrap:anywhere;padding:12px;border-radius:8px;background:#fff;color:#212529;box-shadow:0 3px 16px #0005;font:13px/1.5 sans-serif;pointer-events:auto;z-index:5;';
  var next = (route === null || route === void 0 ? void 0 : route.status) === 'OK' ? (_route$stops = route.stops) === null || _route$stops === void 0 ? void 0 : _route$stops[0] : null;
  tooltip.textContent = [n.label, statusText(n.status), n.driverName ? 'Driver: ' + n.driverName : '', 'Updated: ' + timeAgo(n.location.at) + (stale ? ' - stale GPS' : ''), 'GPS accuracy: ' + distanceText(n.location.accuracyMeters), next ? 'Next stop: ' + distanceText(next.remainingMeters) + ' / ' + durationText(next.etaSeconds) : 'Select trip for route details', next ? 'Arrival: ' + arrivalText(route.computedAt, next.etaSeconds) : ''].filter(Boolean).join('\n');
  pin.setAttribute('aria-describedby', tooltip.id);
  wrap.onmouseenter = () => {
    tooltip.style.display = 'block';
  };
  wrap.onmouseleave = () => {
    tooltip.style.display = 'none';
  };
  pin.onfocus = () => {
    tooltip.style.display = 'block';
    pin.style.outline = '3px solid #0d6efd';
    pin.style.outlineOffset = '3px';
  };
  pin.onblur = () => {
    tooltip.style.display = 'none';
    pin.style.outline = '';
  };
  pin.onkeydown = e => {
    if (e.key === 'Escape') {
      e.stopPropagation();
      tooltip.style.display = 'none';
    }
  };
  wrap.appendChild(tooltip);
  wrap.appendChild(label);
  wrap.appendChild(pin);
  return {
    wrap,
    pin,
    tooltip
  };
}
// A sensible "close enough to read street/building detail, not so close it's disorienting" cap on
// how far fitBounds is allowed to zoom in - matters most for a single-marker view (e.g. a
// customer's own trip with no route yet), where a bare fitBounds on one point can otherwise jump
// straight to the map's maximum zoom.
var MAX_AUTO_ZOOM = 16;
export default function GoogleMapCanvas(_ref) {
  var apiKey = _ref.apiKey,
    mapId = _ref.mapId,
    _ref$nodes = _ref.nodes,
    nodes = _ref$nodes === void 0 ? [] : _ref$nodes,
    _ref$stops = _ref.stops,
    stops = _ref$stops === void 0 ? [] : _ref$stops,
    _ref$polylines = _ref.polylines,
    polylines = _ref$polylines === void 0 ? [] : _ref$polylines,
    route = _ref.route,
    onSelect = _ref.onSelect;
  var host = useRef(null);
  var map = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    ready = _useState2[0],
    setReady = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  useEffect(() => {
    var active = true;
    setError('');
    setReady(false);
    fitted.current = '';
    loadMaps(apiKey).then(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (maps) {
        yield Promise.all([maps.importLibrary('maps'), maps.importLibrary('marker'), maps.importLibrary('geometry')]);
        if (!active) return;
        map.current = new maps.Map(host.current, {
          center: {
            lat: 20.5937,
            lng: 78.9629
          },
          zoom: 5,
          mapId: mapId || 'DEMO_MAP_ID',
          gestureHandling: 'cooperative',
          streetViewControl: false
        });
        new maps.TrafficLayer().setMap(map.current);
        setReady(true);
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()).catch(e => {
      if (active) setError(e.message);
    });
    return () => {
      active = false;
    };
  }, [apiKey, mapId]);
  var fitted = useRef('');
  var focusedPin = useRef('');
  var pinnedTip = useRef('');
  useEffect(() => {
    if (!ready) return undefined;
    var maps = window.google.maps;
    var markers = [];
    var lines = [];
    var bounds = new maps.LatLngBounds();
    var distinct = new Map();
    nodes.filter(n => {
      var _n$location, _n$location2;
      return ((_n$location = n.location) === null || _n$location === void 0 ? void 0 : _n$location.lat) != null && ((_n$location2 = n.location) === null || _n$location2 === void 0 ? void 0 : _n$location2.lng) != null;
    }).forEach(n => {
      var key = n.cabId || "".concat(n.kind, ":").concat(n.id);
      var old = distinct.get(key);
      if (!old || new Date(n.location.at) > new Date(old.location.at)) distinct.set(key, n);
    });
    [...distinct.values()].forEach((n, i) => {
      // Cab/driver location + last-update timing shown right on the map (a label chip above the
      // pin), not just in the sidebar detail panel - readable at a glance, no click needed.
      var _buildCabContent = buildCabContent(n, i, route),
        wrap = _buildCabContent.wrap,
        pin = _buildCabContent.pin,
        tooltip = _buildCabContent.tooltip;
      var key = "".concat(n.kind, ":").concat(n.id);
      pin.dataset.trackingKey = key;
      pin.onclick = () => {
        pinnedTip.current = pinnedTip.current === key ? '' : key;
        tooltip.style.display = pinnedTip.current ? 'block' : 'none';
        onSelect === null || onSelect === void 0 || onSelect(n);
      };
      var escape = pin.onkeydown;
      pin.onkeydown = e => {
        if (e.key === 'Escape') pinnedTip.current = '';
        escape(e);
      };
      if (pinnedTip.current === key) tooltip.style.display = 'block';
      markers.push(new maps.marker.AdvancedMarkerElement({
        map: map.current,
        position: {
          lat: n.location.lat,
          lng: n.location.lng
        },
        content: wrap,
        title: pin.title
      }));
      if (focusedPin.current === key) {
        pin.focus({
          preventScroll: true
        });
        focusedPin.current = '';
      }
      bounds.extend(n.location);
    });
    stops.forEach((stop, i) => {
      var _stop$address, _stop$address2;
      if (((_stop$address = stop.address) === null || _stop$address === void 0 ? void 0 : _stop$address.lat) == null || ((_stop$address2 = stop.address) === null || _stop$address2 === void 0 ? void 0 : _stop$address2.lng) == null) return;
      var pin = new maps.marker.PinElement({
        glyphText: String(i + 1),
        background: '#0d6efd',
        glyphColor: 'white'
      });
      markers.push(new maps.marker.AdvancedMarkerElement({
        map: map.current,
        position: stop.address,
        content: pin.element,
        title: [stop.label, distanceText(stop.remainingMeters), durationText(stop.etaSeconds)].join(' ? ')
      }));
      bounds.extend(stop.address);
    });
    polylines.filter(Boolean).forEach(encoded => {
      var path = maps.geometry.encoding.decodePath(encoded);
      lines.push(new maps.Polyline({
        map: map.current,
        path,
        strokeColor: '#0d6efd',
        strokeWeight: 5,
        strokeOpacity: 0.85
      }));
      path.forEach(p => bounds.extend(p));
    });
    var fitKey = [...distinct.keys()].join(',') + ':' + stops.map(s => {
      var _s$address, _s$address2;
      return "".concat((_s$address = s.address) === null || _s$address === void 0 ? void 0 : _s$address.lat, ",").concat((_s$address2 = s.address) === null || _s$address2 === void 0 ? void 0 : _s$address2.lng);
    }).join(';') + ':' + (polylines.length ? 'route' : 'fleet');
    if (!bounds.isEmpty() && fitted.current !== fitKey) {
      map.current.fitBounds(bounds, 50);
      // Cap the zoom fitBounds lands on (see MAX_AUTO_ZOOM) - only fires once per fit, after the
      // map settles on whatever zoom fitBounds picked.
      maps.event.addListenerOnce(map.current, 'bounds_changed', () => {
        if (map.current.getZoom() > MAX_AUTO_ZOOM) map.current.setZoom(MAX_AUTO_ZOOM);
      });
      fitted.current = fitKey;
    }
    return () => {
      var _document$activeEleme;
      focusedPin.current = ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme = _document$activeEleme.dataset) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.trackingKey) || '';
      markers.forEach(m => {
        m.map = null;
      });
      lines.forEach(l => l.setMap(null));
    };
  }, [ready, nodes, stops, polylines, route, onSelect]);
  return /*#__PURE__*/_jsxs("div", {
    children: [error && /*#__PURE__*/_jsx("p", {
      role: "alert",
      className: "text-danger",
      children: error
    }), /*#__PURE__*/_jsx("div", {
      ref: host,
      role: "region",
      "aria-label": "Google Maps tracking window",
      style: {
        width: '100%',
        height: error ? 80 : 420,
        borderRadius: 12,
        background: '#e9ecef'
      }
    })]
  });
}